import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Form, Spin } from "antd";
import { useEffect, useState } from "react";
import { SelectField } from "../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../../../config/hooks";
import { getPropertyFormData } from "../../ducks/actions";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { ClientsType } from "../../ducks/types";
import { changePropertyManager } from "../../ducks/services";

interface FormValues {
  responsible_for_account: string;
}

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  title: string;
  tableRecord: ClientsType | null;
  fetchPropertyListing: () => void;
}

export default function AccountResponsiblePopUp(props: PropsType) {
  const { fetchPropertyListing, onClose, tableRecord } = props;
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const { control, handleSubmit, setValue } = useForm<FormValues>();

  useEffect(() => {
    if (tableRecord) {
      setValue("responsible_for_account", tableRecord?.manager_id || "");
    }
  }, [tableRecord, setValue]);

  const propertyFormData = useAppSelector(
    (state) => state?.properties?.propertyFormData
  );
  const onCloseHandler = () => {
    onClose();
  };
  const onSubmit = (val: FormValues) => {
    setLoading(true);

    const payload = {
      manager_id: val?.responsible_for_account,
      property_id: tableRecord?.id as string,
    };

    changePropertyManager(payload)
      .then(() => {
        setLoading(false);
        SuccessMessage("Property updated");
        fetchPropertyListing();
        onCloseHandler();
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const btnApi = () => {
    setLoading(true);
    console.log("Button clicked to save changes");
  };

  useEffect(() => {
    if (companyId) {
      dispatch(getPropertyFormData(companyId));
    }
  }, [companyId, dispatch]);
  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.preventDefault();
      }}
    >
      <Spin indicator={antIcon} size="large" spinning={loading}>
        <div className="modalWrapper ">
          <div className="modal_header">
            <div className="title">
              <h3 style={{ marginBottom: "8px" }}>
                Change responsible for the account
              </h3>
              <p style={{ marginBottom: "0px" }}>
                Select who will manage this property’s account.
              </p>
            </div>
          </div>

          <div className="modal_content">
            <SelectField
              fieldName="responsible_for_account"
              label="Responsible for account"
              control={control}
              selectOption={propertyFormData?.managers}
              iProps={{
                placeholder: "Select responsible for account",
              }}
              className="bottom_0"
            />
          </div>

          <div className="modal_footer">
            <Button
              htmlType="button"
              className="outlined-btn"
              type="default"
              size="large"
              onClick={onCloseHandler}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              className="mint-btn"
              type="primary"
              size="large"
              onClick={btnApi}
              loading={loading}
            >
              Save changes
            </Button>
          </div>
        </div>
      </Spin>
    </Form>
  );
}
